module.exports = __webpack_public_path__ + "static/media/cartouche-border.6216a2e4.jpg";